import { faCircleInfo } from '@fortawesome/pro-solid-svg-icons'
import React, { useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useAppSelector } from '../../App/Hooks/reduxHooks'
import { useWindowDimensions } from '../../Common/Hooks/useWindowDimensions'
import {
  CopyButtonContainer,
  CopyButtonIcon,
  CopyButtonText,
  CopyButton,
  CopyLinkInput,
  CopyContainer,
  StepWrapper,
  ActionContainer,
  ToolText,
  CopyMessage,
  CopyMessageText,
  ButtonGroup,
} from '../style'
import { useGetEstablishmentStatsQuery } from '../util/useEstablishmentStatsQuery'

export const AdminHeader: React.FC = () => {
  const [notification, setNotification] = useState<boolean>(false)
  const [shareUrl, setShareUrl] = useState<string>()
  const { t } = useTranslation()
  const { windowWidth } = useWindowDimensions()

  const { data, status } = useGetEstablishmentStatsQuery()

  const establishment = useAppSelector(state => state.establishment)
  const establishmentLanguage = establishment.active?.language || 'en'
  const supportedLanguages = ['en', 'fr', 'nl']
  const language = supportedLanguages.includes(establishmentLanguage)
    ? establishmentLanguage
    : 'en'

  const helpDeskUrl = `https://help.optios.net/${language}/articles/10230030`

  const handleShareButtonClick = () => {
    if (!shareUrl) return
    navigator.clipboard.writeText(shareUrl).then(() => {
      setNotification(true)
      setTimeout(() => setNotification(false), 300000)
    })
  }

  useMemo(() => {
    if (status === 'success') {
      setShareUrl(data._meta.share_url.short)
    }
  }, [status, data])

  return (
    <StepWrapper>
      <ToolText>{t('Share your stats on social media')}</ToolText>
      <ActionContainer>
        <CopyContainer windowWidth={windowWidth}>
          <CopyLinkInput
            windowWidth={windowWidth}
            disabled
            value={shareUrl || t('Loading...')}
          />
          <ButtonGroup>
            <CopyButton
              disabled={!shareUrl}
              windowWidth={windowWidth}
              onClick={() => window.open(shareUrl, '_blank')}>
              <CopyButtonContainer>
                <CopyButtonIcon icon={'eye'} />
              </CopyButtonContainer>
            </CopyButton>
            <CopyButton
              disabled={!shareUrl}
              windowWidth={windowWidth}
              onClick={() => window.open(helpDeskUrl, '_blank')}>
              <CopyButtonContainer>
                <CopyButtonIcon icon={faCircleInfo} />
              </CopyButtonContainer>
            </CopyButton>
            <CopyButton
              windowWidth={windowWidth}
              onClick={handleShareButtonClick}>
              <CopyButtonContainer>
                <CopyButtonIcon icon={'copy'} />
                <CopyButtonText>{t('Copy link')}</CopyButtonText>
              </CopyButtonContainer>
            </CopyButton>
          </ButtonGroup>
          {notification && (
            <CopyMessage isVisible={notification}>
              <CopyMessageText>{t('Copied')}!</CopyMessageText>
            </CopyMessage>
          )}
        </CopyContainer>
      </ActionContainer>
    </StepWrapper>
  )
}
